<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <a-button type="primary" @click="tableAdd">创建</a-button>
      </a-col>
      <a-col :span="5">
        <a-input placeholder="知识点" v-model="keywords" @keyup.enter="tableSearch">
          <a-icon slot="suffix" type="search"></a-icon>
        </a-input>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="name" title="知识点" data-index="name" />
        <a-table-column key="show_name" title="第三级名字" data-index="show_name" />
        <a-table-column key="rank" title="级层" data-index="rank" />
        <a-table-column width="100px" key="status" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" width="180px" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1, pid: item.pid })" class="active_btn"
              size="small" type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0, pid: item.pid })" class="active_btn"
              size="small" type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
            <a-dropdown :trigger="['click']" v-if="item.status == 1">
              <a-button size="small" type="link" icon="more" />
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="tableDel({ id: item.id })">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="知识点" centered mask=true @ok="modalSave" @cancel="modalCancel" :class="modelclass">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-tree-select :value="form.pid" style="width: 100%" :treeData="data"
            :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }" placeholder="选择上级知识点"
            @change="selectItem" allowClear>
          </a-tree-select>
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.name" placeholder="知识点名字" />
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";

export default {
  components: { AFormItem },
  data() {
    return {
      keywords: "",
      data: [],
      pageinfo: false,
      loading: false,
      visible: false,
      modalSaveadd: true,
      form: {
        id: "",
        name: "",
        pid: ""
      },

    };
  },
  mounted() {
    this.tableSearch();
  },
  methods: {
    selectItem(pid) {
      console.info("pid", pid);
      this.form.pid = pid;
    },
    changeStatus(data) {
      this.$axios
        .post("/api/QuestionNode/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.searchbtn();
    },
    tableSearch() {
      this.getTableList({ keyword: this.keywords });
    },
    getTableList(data) {
      this.$axios
        .post("/api/QuestionNode/index", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.pid = item.pid;
      this.visible = true;

    },

    tableAdd() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.visible = true;
    },
    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前知识点吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/QuestionNode/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getTableList();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    modalSave() {

      if (this.modalSaveadd) {
        this.modalSaveadd = false;
        let url = "/api/QuestionNode/edit";
        if (!this.form.id) {
          url = "/api/QuestionNode/add"
        }
        this.$axios
          .post(url, { data: this.form })
          .then(res => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定"
              });
              this.modalSaveadd = true;
            } else {
              this.getTableList();
              this.modalSaveadd = true;
              this.visible = false;
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    modalCancel() {
      this.visible = false;
    }
  }

};
</script>
<style>
.active_btn {
  margin-left: 5px;
}

.modelclass {
  padding-top: 400px;
  width: 600px;
}
</style>